import { useEffect } from "react";
import Section from "../Section";
import httpClient from "../../custom-hooks/httpClient";
import { toast } from "react-toastify";

function StartBvnVerification() {
  useEffect(() => {
    httpClient
      .get("/bvn/start?channel=web")
      .then(({ status, data }) => {
        if (status === 200 && data.redirectUrl) {
          window.location = data.redirectUrl;
        }
      })
      .catch((err) => {
        toast.error(err.response.data.message);
      });
  }, []);

  return (
    <Section
      title="Start BVN Verification"
      text="BVN verificaion will soon begin...."
    />
  );
}

export default StartBvnVerification;
